import {
  type PaidSpecContractType,
  type SpecContractType,
} from '@/common/types/contract';

const titles: Record<SpecContractType | PaidSpecContractType, string> = {
  Custom: 'Custom Contract',
  Golden: 'Premium Contract',
  GoldenPlus: 'Premium+ Contract',
  Grand: 'Grand Contract',
  GrandPlus: 'Grand+ Contract',
  Blitz: 'Blitz Contract',
  BlitzPlus: 'Blitz+ Contract',
};

export { titles };
